import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Main from 'layouts/Main';

import { Adaptation, Character, Code4Fun, Day1, Flok, Genus, Idimatiquex, MathRelay, Mooka, Mun, Mythological, Novus, RoboMaster, Veritas } from './components';
import Day2Goonj2026 from './components/Day2Goonj2026';


const FaqGroupItem = () => {
  const theme = useTheme();
  return (
    <Main>
      <Box>
        <br></br>
        <Typography  variant='h4' align='center' fontWeight={800}>
          GOONJ 2026
        </Typography>
        <br></br>
        <br></br>

        <Typography variant='h6' align='center' fontWeight={700}>
          INTRODUCTION
        </Typography>

        <Box id='Day1' marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>
          <Typography fontSize="x-small">
            <br />
            <br />
              Date: 10 & 11 July 2026
          </Typography>
          <Typography
            variant={'h6'}
            color={'primary'}
            align={'center'}
            fontWeight={'normal'}
          ><br/>
            <strong>“Goonj 2026: Inspiring young minds through creativity, collaboration and excellence.”</strong>

            <br/>
          </Typography>

          <Typography
            variant={'subtitle1'}
            align='justify'

          >
            National Public School, Yeshwanthpur, proudly hosted its flagship inter-school cultural and intellectual fest, Goonj 2026, over two vibrant days.
            Bringing together <strong>over 900 enthusiastic participants from 21 schools, the fest featured 28 thoughtfully curated events across 15 academic departments,</strong>
            offering students of Classes 3 to 12 an enriching platform to showcase their talents across literature,
            languages, science, mathematics, commerce, technology, social sciences, music and the performing arts.          
            <br></br>
            <br></br>
        The fest commenced each morning with an inaugural ceremony featuring the lighting of the lamp, invocation, welcome address and introduction of the esteemed panel of judges.
        Principal <strong>Ms Sheeja Manoj</strong> encouraged every participant to compete with confidence, integrity and enthusiasm, reminding them that the true spirit of Goonj lies in learning, 
        collaboration and personal growth. What followed was a vibrant celebration of creativity,
        innovation and intellectual excellence as students immersed themselves in a wide spectrum of thoughtfully designed competitions. 
            <br></br>
            <br></br>
            The <strong>Performing Arts</strong> came alive through Pages to Present, Natya Darpan, Nrityarupakam and Nritya Nataka, where literature, mythology and history were brought to life through expressive monologues, 
            theatre and dance. Trivanta challenged students to create imaginative crossover plays, while Rhythmscape, the inter-school band competition, captivated audiences with outstanding musical performances. 
            Theme Walk celebrated diverse urban identities through creative fashion and character portrayal.     
            <br></br>
            <br></br>
            The fest also fostered <strong>Debates, Diplomacy & Critical Thinking</strong> through events such as Debattle, Charcha Vedike, Veritas Interna, Veritas Vincit,
            Sansad and Model United Nations (MUN). From parliamentary proceedings and courtroom simulations to panel discussions and international diplomacy, participants demonstrated articulate communication, analytical thinking,
            leadership and collaborative problem-solving while engaging with contemporary issues from local and global perspectives.       
            <br></br>
            <br></br>
            <strong>Creativity, Design & Innovation</strong> found expression through Haasya Abhinay, Adornia and LogoTech, where participants showcased humour, artistic craftsmanship and digital creativity. Younger learners explored storytelling through Terra Tales,
            while Pixel Patakha transformed traditional games into engaging mathematical experiences that blended imagination with logical thinking.        
            <br></br>
            <br></br>
            The domains of <strong>Science, Technology & Engineering</strong> inspired participants through Field Fiesta, Science Relay and Mind Over Mystery, encouraging scientific inquiry, teamwork and evidence-based reasoning. RoboMaster – CloudAlert Quest challenged students to develop innovative weather-monitoring solutions using robotics, 
            while Webfinity tested coding proficiency, creativity and web design skills through a live website development challenge.
            <br></br>
            <br></br>
            The spirit of <strong>Commerce, Entrepreneurship & Mathematical Excellence</strong> was showcased through FinSpectra, Venture Crucible and Mercatus Dominus, where participants demonstrated financial literacy, business strategy and entrepreneurial acumen. Meanwhile, Trail Blazers and Math Escape Room encouraged mathematical reasoning, innovation and collaborative problem-solving through exciting design and puzzle-based challenges.
            <br></br>
            <br></br>
            The fest concluded with a vibrant valedictory ceremony celebrating the achievements of the participants and the unwavering support of the schools, judges, teachers and volunteers.
             The Overall Championship was awarded <strong>to Brigade School Malleshwaram</strong>, recognising the school&apos;s exceptional performance across a diverse range of events. Goonj 2026 once again proved to be far more than an inter-school competition—it was a celebration of talent, creativity, collaboration and experiential learning, 
            leaving participants inspired to continue exploring, innovating and excelling beyond the classroom.
            <br></br>
            <br></br>
          </Typography>
          <br></br>
          <Typography variant='h6' align='center' id='Day1' fontWeight={700}>
            DAY 1
          </Typography>
        <Box
  sx={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    mb: 2,
  }}
>
  <Button
    href="/event-gallarygoonj2026"
    variant="contained"
    sx={{
      display: "inline-flex",
      width: "auto",
      minWidth: "unset",
      flexShrink: 0,

      fontWeight: 900,
      px: 3.4,
      py: 1.25,
      borderRadius: "999px",
      textTransform: "none",
      letterSpacing: 0.2,
      whiteSpace: "nowrap",

      border: "1px solid rgba(255, 255, 255, 0.55)",
      boxShadow:
        "0 10px 24px rgba(33, 150, 243, 0.28), 0 0 0 1px rgba(33, 150, 243, 0.18)",

      background:
        "linear-gradient(120deg, #0d47a1 0%, #1976d2 42%, #64b5f6 72%, #1565c0 100%)",
      backgroundSize: "220% 220%",

      position: "relative",
      overflow: "hidden",

      animation:
        "galleryPulse 1.9s ease-in-out infinite, galleryGradient 5s ease infinite",

      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.55) 45%, transparent 70%)",
        transform: "translateX(-100%)",
        animation: "galleryShine 2.2s linear infinite",
      },

      "& span": {
        position: "relative",
        zIndex: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      },

      "&:hover": {
        background:
          "linear-gradient(120deg, #0d47a1 0%, #1976d2 42%, #64b5f6 72%, #1565c0 100%)",
      },

      "@keyframes galleryPulse": {
        "0%, 100%": {
          boxShadow:
            "0 0 0 0 rgba(33, 150, 243, 0.36), 0 10px 24px rgba(33, 150, 243, 0.28)",
        },
        "50%": {
          boxShadow:
            "0 0 0 9px rgba(33, 150, 243, 0.13), 0 14px 30px rgba(33, 150, 243, 0.36)",
        },
      },

      "@keyframes galleryGradient": {
        "0%, 100%": {
          backgroundPosition: "0% 50%",
        },
        "50%": {
          backgroundPosition: "100% 50%",
        },
      },

      "@keyframes galleryShine": {
        "0%": {
          transform: "translateX(-100%)",
        },
        "100%": {
          transform: "translateX(100%)",
        },
      },
    }}
  >
    <span>Event Gallery</span>
  </Button>
</Box>
  <Day1 />
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Aarush</Typography>
              <Typography align='right'> - Haasya Abhinay</Typography>

            </Box>
            <AccordionDetails>
Expressions, humour and laughter turned every performance into pure delight.
            </AccordionDetails>

            <Character/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}> Back to DAY 1</a>
            </Box>

          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Chetana</Typography>
              <Typography align='right' > - Nritya Nataka</Typography>

            </Box>
            <AccordionDetails>
History unfolded through captivating dance, drama and vibrant Kannada traditions.
            </AccordionDetails>

            <Idimatiquex />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Litage Faire </Typography>
              <Typography align='right' >- Trivanta</Typography>

            </Box>
            <AccordionDetails>
When literary legends shared one stage, creativity knew no bounds.
            </AccordionDetails>

            <Mythological />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Delta</Typography>
              <Typography align='right' >- Field Fiesta</Typography>

            </Box>
            <AccordionDetails>
Young minds nurtured sustainability through innovation and hands-on learning.
            </AccordionDetails>

            <Flok/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Litage Faire</Typography>
              <Typography align='right' >- Pages to Present</Typography>

            </Box>
            <AccordionDetails>
        Timeless characters stepped into today&apos;s world, captivating the audience with imagination and expression.
            </AccordionDetails>

            <Novus />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Radical</Typography>
              <Typography align='right' >- Pixel Patakha</Typography>

            </Box>
            <AccordionDetails>
Strategy, creativity and mathematics blended into colourful pixel masterpieces.
            </AccordionDetails>

            <MathRelay />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Mirrors</Typography>
              <Typography align='right' >- Veritas Interna</Typography>

            </Box>
            <AccordionDetails>
Exploring the human mind through observation, analysis and psychological insight.          
            </AccordionDetails>

            <Adaptation/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Mirrors</Typography>
              <Typography align='right' >- Terra Tales</Typography>


            </Box>
            <AccordionDetails>
          History and geography merged into stories that brought the past vividly to life.       
            </AccordionDetails>

            <Code4Fun/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>
          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Space bar</Typography>
              <Typography align='right' >- LogoTech</Typography>


            </Box>
            <AccordionDetails>
            Creative ideas found their identity through innovative digital logo designs.
            </AccordionDetails>

            <RoboMaster />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Exodia</Typography>
              <Typography align='right' > - Venture Crucible</Typography>

            </Box>
            <AccordionDetails>
Entrepreneurial minds thrived under pressure, transforming challenges into opportunities.
            </AccordionDetails>

            <Mooka/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' > Exodia</Typography>
              <Typography align='right' >- Mercatus Dominus</Typography>

            </Box>
            <AccordionDetails>
Business acumen, strategy and teamwork drove every competitive decision.
            </AccordionDetails>

            <Veritas />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >NPSYPR MUN </Typography>
              <Typography align='right' >- MUN</Typography>

            </Box>
            <AccordionDetails>
Young diplomats negotiated, debated and collaborated for a better tomorrow.  </AccordionDetails>

            <Mun/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >Stroke of genius</Typography>
              <Typography align='right' >- Adornia</Typography>

            </Box>
            <AccordionDetails>
Simple materials blossomed into stunning works of wearable art.  
            </AccordionDetails>

            <Genus/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>



          {/* 
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Marketus Deus</Typography>
    <Typography align='right' >- Masters of Markets</Typography>

  </Box>
  <AccordionDetails>
  From mock stock trading to angel investing — mastering the art of finance.
  </AccordionDetails>

  <Marketus/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left' >Dezainovate</Typography>
    <Typography align='right' >- Concepts to Catwalk</Typography>

  </Box>
  <AccordionDetails>
  From imaginative product design to creative problem-solving, culminating in a striking runway showcase of contrasting aesthetics.
  </AccordionDetails>

  <Dezainovate/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
  </Box>
</Box> */}








          <Day2Goonj2026/>

        </Box>
      </Box>
    </Main>
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Goonj2026 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Goonj2026;
